import "../assets/css/galleries.css";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useState, useEffect } from "react";
import { Loading } from "../components/loading";
import { PopupDialog } from "../components/popupDialog";

export const Galleries = ({ galleries = [], isShowSectionTitle = true }) => {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const openModal = (image) => {
    setCurrentImage(image);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (galleries && galleries.length > 0) {
      setLoading(false);
    }
  }, [galleries, isShowSectionTitle]);

  return (
    <section id="galleries">
      {loading ? (
        <Loading />
      ) : (
        <div className="galleries-container">
          {isShowSectionTitle && (
            <div>
              <h3>GALLERIES</h3>
              <hr />
            </div>
          )}
          <div className="images-container">
            <ImageList variant="quilted" cols={8} rowHeight={100} gap={12}>
              {galleries.map((image, index) => {
                const cols = index % 3 === 0 ? 2 : 1;
                const rows = index % 3 === 0 ? 2 : 1;
                return (
                  <ImageListItem key={index} cols={cols} rows={rows}>
                    <img
                      className="image-list-item"
                      src={image}
                      alt={image}
                      onClick={() => openModal(image)}
                    />
                  </ImageListItem>
                );
              })}
            </ImageList>
          </div>
        </div>
      )}
      <PopupDialog
        name="imageModal"
        open={open}
        onClose={handleClose}
        content={
          <div className="image-container">
            <img
              src={currentImage}
              alt="Enlarged"
              className="image-container-img"
            />
          </div>
        }
      />
    </section>
  );
};
